const axios = require('axios');
const CryptoJS = require('./aes.js'); //引用AES源码js
const key = CryptoJS.enc.Utf8.parse("sdlfjhhe83232dwm"); //十六位十六进制数作为秘钥
const iv = CryptoJS.enc.Utf8.parse(16);//十六位十六进制数作为秘钥偏移量
/**
 * aes ecb加密方法
 */
function AesEncryptECB(phone, callback) {
    messageValid();
    axios({
        method: "post",
        url: "api/user/logs",
        data: {
            'phone': phone
        },
    }).then((res) => {
        if (res.data.code == 200) {
            var token = res.data.data.slice(3, res.data.data.length - 3);
            let srcs = CryptoJS.enc.Utf8.parse(token);
            let encrypted = CryptoJS.AES.encrypt(srcs, key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            });
            console.log(encrypted);
            return callback(encrypted.toString());
        }
    });

}
function messageValid() {
    axios({
        method: "post",
        url: "api/user/messageValid",
        data: {},
    }).then((res) => {

    });
}
//暴露接口
module.exports = {
    AesEncryptECB,
}



// WEBPACK FOOTER //
// ./src/utils/aes_util.js